import { useEffect } from 'react';

const PageLoader = () => {
  const loader = document.querySelector('.rootPreloader');
  const hideRootPreLoader = () => loader.classList.add('rootPreloader--hide');
  useEffect(() => {
    loader.classList.remove('rootPreloader--hide');
    return () => {
      hideRootPreLoader();
    };
  }, []);

  return null;
};

export default PageLoader;
